module.exports = __webpack_public_path__ + "static/14-58a9eaef800733fe0b03cb1bd402ec7c.png";